// extracted by mini-css-extract-plugin
export var arrow = "_3v-6";
export var changeItem = "_3v-3";
export var changesHeader = "_3v-1";
export var changesList = "_3v-2";
export var container = "_3v-0";
export var pathLabel = "_3v-4";
export var value = "_3v-7";
export var valuesContainer = "_3v-5";